import { OSS_CDN } from '@/utils/pathConfig';
import { Title } from '../title/index';
import { Paragraph } from '../paragraph/index';
import { Underline } from '../underline';
import styles from './../../index.module.scss';
// 待办事项
// 1、更新及发布日期
// 2、生效日期
// 3、海底捞外送（微信）小程序收集个人信息清单
// 4、海底捞外送（支付宝）小程序收集个人信息清单
// 5、海底捞外送（快手）小程序收集个人信息清单
// 6、海底捞火锅外送（京东）小程序收集个人信息清单
// 7、（一）海底捞外送小程序需获取的与个人信息相关的权限列表
// 8、小程序与第三方共享信息清单
// 9\海底捞外送（微信、支付宝）小程序内嵌第三方SDK详情
// 10\海底捞外送（快手）小程序内嵌第三方SDK详情
// 11\关联公司
// 12\个人信息定义：
export const Privacy = () => {
  return (
    <div>
      <div className={styles.privacyName}>海底捞外送小程序隐私政策</div>
      <Paragraph bold>更新及发布日期:【2023】年【7】月【31】日</Paragraph>
      <Paragraph bold>生效日期：【2023】年【7】月【31】日</Paragraph>
      <Title bold>提示条款：</Title>
      <Paragraph>
        感谢您对海底捞品牌的信任！四川新派餐饮管理集团有限公司（注册地址：四川省成都市简阳市江安北街41号旭海时代广场17层17-5号）及其关联公司（以下简称“海底捞”或“
        <b>我们</b>
        ”）非常重视用户（“<b>您</b>
        ”）的个人信息及隐私的保护，我们深知个人信息对您的重要性，并严格遵循法律法规，竭力保障您的信息安全。鉴于此，我们制定本《海底捞外送小程序隐私政策》（下称“隐私政策”）详细说明我们在收集、使用及存储您相关个人信息是的相关规则。
      </Paragraph>
      <Paragraph bold>
        我们将通过在中国大陆境内运营和授权的第三方线上平台（包括微信、支付宝、京东、快手）的海底捞外送小程序为您提供产品或服务。为了更好的保护您的信息，请您在使用我们提供的各项产品或服务前，仔细阅读并充分理解本政策（重点内容我们已将字体加粗，请您特别关注），并据此作出您认为适当的选择。
      </Paragraph>
      <Paragraph bold>
        如您对本政策或与本政策相关的事宜有任何问题或疑问，您可通过本隐私政策规定的方式或海底捞客服电话（4009107107）与我们联系。
      </Paragraph>
      <Title>隐私政策目录：</Title>
      <Paragraph bold>一、我们如何收集和使用您的个人信息</Paragraph>
      <Paragraph bold>二、我们如何共享、转让、披露您的个人信息</Paragraph>
      <Paragraph bold>三、我们如何保护您的个人信息</Paragraph>
      <Paragraph bold>四、我们如何存储您的个人信息</Paragraph>
      <Paragraph bold>五、您如何管理您的个人信息</Paragraph>
      <Paragraph bold>六、未成年人隐私保护</Paragraph>
      <Paragraph bold>七、我们如何使用 COOKIES 和同类技术</Paragraph>
      <Paragraph bold>八、本政策的更新</Paragraph>
      <Paragraph bold>九、与我们取得联系</Paragraph>
      <Title bold>一、 我们如何收集和使用您的个人信息</Title>
      <Paragraph>
        我们会遵循合法、正当、必要、诚信的原则，出于本政策所述的以下目的，收集和使用您在使用我们的服务过程中主动提供或因使用我们的服务而产生的个人信息。
        <b>
          如果我们要将您的个人信息用于本政策未载明的其它用途或场景，或基于特定目的将收集而来的信息用于其他目的，我们将以合理的方式向您告知，并再次征得您的同意。
        </b>
      </Paragraph>
      <Paragraph>
        在您使用我们的产品或服务时，我们需要或可能需要收集和使用的您的个人信息包含两种情形：根据《常见类型移动互联网应用程序必要个人信息范围规定》，海底捞外送小程序属于“餐饮外卖类”，基本功能服务包括“餐饮购买及外送，如餐饮配送、到店自取”，必要个人信息包括：
        <b>
          1.注册用户移动电话号码；2.收货人姓名（名称）、地址、联系电话；3.支付时间、支付金额、支付渠道等支付信息。
        </b>
        您同意本隐私政策仅代表您知悉和同意使用餐饮购买及外送的功能时我们收集、处理相关必要信息，不代表您同意我们收集、处理非必要个人信息。
      </Paragraph>
      <Paragraph>
        您可以通过【我的——设置——隐私政策】再次查看本隐私政策。
      </Paragraph>
      <Paragraph>
        您可以在下列【个人信息收集清单】中可以查阅我们收集您个人信息的概要情况：
      </Paragraph>
      <img
        className={styles.image}
        alt="海底捞外送（微信）小程序收集个人信息清单"
        src={`${OSS_CDN}user.png`}
      />
      <img
        className={styles.image}
        alt="海底捞外送（支付宝）小程序收集个人信息清单"
        src={`${OSS_CDN}zfb.png`}
      />
      <img
        className={styles.image}
        alt="海底捞外送（快手）小程序收集个人信息清单"
        src={`${OSS_CDN}ks.png`}
      />
      <img
        className={styles.image}
        alt="海底捞火锅外送（京东）小程序收集个人信息清单"
        src={`${OSS_CDN}jd.png`}
      />
      <Title bold>我们会出于以下目的收集和使用您的个人信息：</Title>
      <Paragraph>
        为了方便您阅读，以下涉及<b>个人信息</b>的加粗处理，
        <Underline bold>敏感个人信息</Underline>
        的加粗和下划线处理。
      </Paragraph>
      <Title bold>1.会员账号注册及登录</Title>
      <Paragraph>
        1.1当您使用海底捞外送小程序并注册成为我们的会员时，您需要提供手机号码以创建海底捞会员账号，同时我们可能会通过发送短信验证码的方式来验证您的身份，以帮助您完成注册。我们会
        <b>使用您的剪切板功能和信息，以使您能快捷填写验证码</b>
        。若您未通过或完成身份认证，您将无法成功注册账号。如果您仅需使用浏览服务时，您无需注册会员及提供上述信息。
      </Paragraph>
      <Paragraph>
        1.2
        当您在注册或登录账号时使用一键登录功能，经过您的同意，并根据我们与供应商的合作，我们会收集您的
        <b>手机号码</b>和<b>网络运营商信息</b>
        ，并将您设备的手机号码作为您注册或登录的手机号码，以便为您提供快捷的注册及登录服务。如您不希望使用一键登录的功能，您可选择其他方式注册、登录海底捞会员账号。
      </Paragraph>
      <Paragraph>
        1.3
        当您使用第三方平台账号注册或登录海底捞应用注册为会员时，我们会在获得您授权同意的前提下，从该第三方平台处获取您的第三方平台账户信息，包括您向该平台提供的
        <b>手机号码</b>
        ，以及您在该平台的
        <b>用户唯一标识、昵称、头像及您授权的其他信息）</b>
        ，以用于识别您的身份及方便您快捷注册或登录。
      </Paragraph>
      <Paragraph>
        1.4
        如您已经注册海底捞会员账号，需要将第三方平台账号与海底捞账号进行绑定时，我们会在获得您授权同意的前提下，从该第三方平台获得您在该等第三方平台账号下所保存的
        <b>
          该第三方平台的用户唯一标识、昵称、头像、手机号码及您授权的其他信息；
        </b>
        您不进行绑定不会影响您的海底捞会员身份。
      </Paragraph>

      <Paragraph>
        1.5 当您编辑个人信息页面时，您可以填写或修改您的
        <b>会员昵称、头像、性别及出生日期、手机号码</b>
        ，以完善您的会员资料。您可以不提供这些信息，不会影响您使用网络平台的基本服务功能。
      </Paragraph>
      <Paragraph>
        （前述所有信息均构成您的<b>海底捞会员账号信息</b>）
      </Paragraph>
      <Title bold>2. 为您提供点餐、送餐服务</Title>
      <Paragraph>
        2.1 当您通过海底捞外送小程序，使用自提取餐功能时，我们会收集您的
        <b>
          订单信息（包括订单编号、所订购的内容或服务、下单时间、服务门店、
          <Underline bold>您应支付的金额及支付方式）</Underline>
        </b>
        。为了方便您快速查找附近的门店，在您的同意下，我们会收集您的
        <Underline bold>地理位置信息</Underline>
      </Paragraph>
      <Paragraph>
        2.2 当您使用海底捞送餐服务时，我们会收集您或您指定收货人的
        <b>
          姓名、性别、手机号码、<Underline bold>收货地址</Underline>
          、订单信息
        </b>
        。为了方便您快速查找附近的门店，在您的同意下，我们会收集您的
        <Underline bold>地理位置信息</Underline>。我们需要将
        <b>收货人信息（姓名、手机号码、地址）、订单信息</b>
        中的必要信息与我们合作的第三方伙伴（包括外送平台、第三方配送公司及技术合作伙伴）共享，以使您的订单能够正常送达。
      </Paragraph>
      <Title bold>3. 为您提供购买、使用优惠券或其他商品的服务</Title>
      <Paragraph>
        3.1
        当您通过第三方平台（快手、微信、支付宝、京东）购买或领取优惠券并进入海底捞外送小程序兑换优惠券时，我们会收集您的第三方平台公开信息，
        <b>（包括头像、昵称）</b>
        、您所购买或领取的优惠券名称、您购买或领取优惠券的日期、您的优惠券使用信息和您的购券
        <b>手机号</b>，以便卡券核销及兑换服务。
      </Paragraph>
      <Paragraph>
        另外请您注意您在第三方平台的操作可能涉及第三方平台收集您的个人信息，第三方平台收集您个人信息的行为不在本隐私政策适用范围，提示您仔细阅读第三方平台的隐私政策。
      </Paragraph>
      <Paragraph>
        3.2
        当您在我们的线上平台购买我们发行的线上欢乐卡与相关服务时，根据国家法律法规的要求，我们还可能会根据规定要求您提供实名信息，包括您的
        <b>电话号码、姓名、</b>
        <Underline bold>身份证信息</Underline>
        。如果您不提供上述信息，可能无法购买线上欢乐卡，但是不影响您使用其他基本功能。
        <b>
          请以具体场景和页面下提醒您注意的对应的欢乐卡章程的约定或说明为准。
        </b>
      </Paragraph>
      <Title bold>4. 为您提供活动参与服务</Title>
      <Paragraph>
        4.1
        在海底捞官方小程序的场景下，我们将通过小程序所在的第三方平台投放海底捞会员专属优惠券等福利或参与营销活动。为此，如您为该第三方平台的用户，您需要通过您的该第三方平台账号注册或绑定您的海底捞会员账号后方能领取相关会员福利或参与营销活动。为此，
        <b>
          出于保障您的合法权益、防范欺诈等的目的，在领取会员福利或参与营销活动时，您同意并授权我们可从该等第三方平台处获取并传输您的第三方平台用户唯一标识，以及会员福利的领取、核销信息。
        </b>
      </Paragraph>
      <Paragraph>
        4.2
        如您参与我们举办的线上或线下营销活动时，在获得您的同意下，我们可能会收集您的
        <b>姓名、手机号码、</b>
        <Underline bold>收件地址（简称“活动信息”）</Underline>
        ，为核验您的身份，或及时向您兑奖和寄送奖品，我们需要与合作的第三方伙伴（如第三方供应商、第三方配送平台）共享您的
        <Underline bold>活动信息</Underline>
        中的必要信息。拒绝提供仅会影响您参与相关活动，但不会影响您正常使用其他功能或服务。
      </Paragraph>
      <Title bold>5. 为您提供支付、充值与开票的服务</Title>
      <Paragraph>
        5.1
        当您在下单或充值时，您可以选择与我们合作的第三方支付机构（如支付宝、微信支付、银联等，合称“支付机构”）所提供的支付服务进行支付。为实现支付服务的需要，我们会收集并将您的
        <b>订单编号与</b>
        <Underline bold>交易金额</Underline>
        分享给这些支付机构，以下达支付指令并帮助您完成支付。
      </Paragraph>
      <Paragraph>
        5.2如您向我们申请开具电子发票，我们可能需要向您收集和使用您的企业开票信息，包括订单编号、下单时间、发票金额、抬头类型、发票抬头、税号、企业地址、企业电话、开户银行、银行账号，以及接收发票的联系方式，
        <b>电子邮箱或手机号码</b>，具体以发票申请页面所示为准。
      </Paragraph>
      <Title bold>6. 为您提供客服与售后服务</Title>
      <Paragraph>
        6.1 当您在海底捞线上平台使用在线客服进行咨询或投诉建议时，我们会收集您的
        <b>账号信息、</b>咨询和投诉建议的内容、<b>咨询的订单相关信息，</b>
        以便于为您提供咨询反馈。
        <b>
          如果您在说明投诉或表扬的相关事件时，需要上传图片的，我们会向您申请开启“相机（摄像头）权限”或“相册（存储）权限”，
        </b>
        如果您上传的图片涉及您的敏感个人信息，可能对您的隐私和权益有较大影响，请您保护好自身隐私，避免上传含有隐私因素或敏感个人信息的图片，我们会对您上传的图片按照法律规定进行严格保护。当您与我们联系时，
        <b>
          我们可能会保存您与我们的沟通内容、点评文本、投诉内容，或您留下的联系方式信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
        </b>
      </Paragraph>
      <Paragraph>
        当您在海底捞线上平台投诉并要求海底捞回访时，
        <b>
          我们会收集您的手机号码，以便于我们进行回访。如果您拒绝提供您的手机号码我们将无法实现回访，但不会影响您使用其他功能。
        </b>
      </Paragraph>
      <Title bold>7. 为您提供消息通知服务</Title>
      <Paragraph>
        7.1
        您可以通过我们提供的消息通知服务（包括短信、应用推送、公众号/社群消息），获得与您订单状态有关的信息、营销活动信息、以及其他服务信息。
        <b>您可以根据系统页面弹窗，选择同意打开消息通知权限。</b>
        获得您的同意后，我们可能会收集和使用您的
        <b>联系方式、订单信息、设备信息</b>
        并将上述信息中的必要信息共享给我们指定的提供消息通知服务的供应商，以便向您提供消息通知服务。
        <b>
          若您选择不同意打开消息通知权限，您将不会接收到以上信息，但您仍正常使用其他功能或服务。
        </b>
      </Paragraph>
      <Paragraph>
        如果您后续不想接受我们给您发送的此类信息或消息，您可以回复<b>“T”</b>
        （或所显示的其他退订指令）来取消接收此类手机短信或消息，及通过关闭手机相关通知权限停止接收来自网络平台的推送消息，或者关闭小程序站内消息或公众号消息提示。
      </Paragraph>
      <Title bold>8. 为您提供信息搜索和展示服务</Title>
      <Paragraph>
        8.1
        您可以通过搜索来找到您所需要的商品或服务，我们会收集和使用您的搜索内容、搜索记录，以便于向您快速匹配您所需要的内容或可能更感兴趣的服务，同时亦可以改进我们的产品和服务。
      </Paragraph>
      <Title bold>9 为您调用权限提供其他附加服务</Title>
      <Paragraph>
        当您与我们的互动、使用以下附加功能时，我们可能会收集和使用您的个人信息。
        <b>
          如果您不提供这些信息，您可能无法使用这些可以为您所带来的附加功能或服务，但不会影响您享受我们为您提供的基础服务或功能。
        </b>
        这些附加功能包括：
      </Paragraph>
      <Paragraph>
        9.1 基于<Underline bold>地理位置</Underline>
        授权的信息展示：经您授权后，我们会收集您在使用我们服务过程中产生的位置信息。当您通过系统授权开启移动设备的定位功能，并使用基于位置信息提供的服务时，我们会收集和使用您的位置信息（包括您授权的GPS位置信息以及WLAN接入点、蓝牙和基站传感器信息）以便为您提供、实现或推荐相关服务（例如您不需要手动输入所在地理位置就可定位或获得相关服务、估算海底捞门店与您之间的实际距离等）。您可以在您设备的系统中关闭定位设置以停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。
      </Paragraph>
      <Paragraph>
        9.2 基于<Underline bold>相机</Underline>
        授权的附加功能：您可使用该附加功能完成“扫一扫”功能，
        <b>
          我们会向您申请开启“相机（摄像头）权限”（即“摄像头权限”或“拍摄权限”）
        </b>
        ，以便于为您识别您扫描的二维码。如果您拒绝开启相机（摄像头）权限将无法使用此功能，但不影响您使用海底捞App的其他功能。
      </Paragraph>
      <Paragraph>
        9.3 基于<Underline bold>相机</Underline>
        授权的附加功能：您可以选择开启系统的相册权限，通过主动上传图片、视频等方式授权我们访问您的相册，以便于您通过上传照片或视频等方式发布内容与客服沟通功能。我们会收集您选择上传发布的上述信息，若您不使用或停止使用以上功能时，可以不允许或关闭此权限。
      </Paragraph>
      <Paragraph>
        <b>以上权限，均不会默认开启。</b>
        我们会在启用该功能前获得您的确认，您也可以通过您设备系统中的设置功能逐项查看这些权限的开启状态，并可以决定随时开启或关闭该等权限。
        <b>
          即使经过您的授权，我们已获得这些权限，我们也仅会在相关功能或服务需要时而收集您的信息。
        </b>
      </Paragraph>
      <Paragraph>
        有关更详细的设备权限使用说明详见下文“海底捞应用设备权限调用说明”。
      </Paragraph>
      <Title bold>10. 征得授权同意的例外</Title>
      <Paragraph>
        请您理解，根据法律法规，我们在如下情况中处理您的个人信息无需征得您的授权同意：
      </Paragraph>
      <Paragraph>10.1 为订立、履行您作为一方当事人的合同所必需；</Paragraph>
      <Paragraph>10.2 为履行法定职责或者法定义务所必需；</Paragraph>
      <Paragraph>
        10.3
        为应对突发公共卫生事件，或在紧急情况下为保护自然人的生命健康和财产安全所必需；
      </Paragraph>
      <Paragraph>
        10.4
        为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
      </Paragraph>
      <Paragraph>
        10.5
        依照《个人信息保护法》规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
      </Paragraph>
      <Paragraph>10.6 法律、行政法规规定的其他情形。</Paragraph>
      <Title bold>11. 海底捞应用设备权限调用说明</Title>
      <Paragraph>
        我们访问您的各项设备权限是为了向您提供服务以及保障您的账号安全，经过您的授权后我们会开启相关权限，您可以随时在系统中取消授权。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请您参考设备及系统开发方说明或指引。
        <b>
          请您注意，除非另有说明，否则您开启任一权限，即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
        </b>
      </Paragraph>
      <Title bold>（一）海底捞外送小程序需获取的与个人信息相关的权限列表</Title>
      <img
        className={styles.image}
        alt="（一）海底捞外送小程序需获取的与个人信息相关的权限列表"
        src={`${OSS_CDN}userqx.png`}
      />
      <Paragraph bold>
        特别提醒：由于各平台、各设备、各系统及我们所提供服务可能存在差异，（1）我们在各个小程序内获取的权限以及告知方式可能略有不同，具体请以该小程序所在平台的页面提示为准；（2）在不同设备或不同系统中，权限的提示方式、显示方式及关闭方式可能有所不同，具体请以该设备及系统开发方的说明或指引为准。
      </Paragraph>
      <Title bold>二、 我们如何共享、转让、披露您的个人信息</Title>
      <Paragraph>
        对于您的个人信息，我们仅在本隐私政策所述目的和范围内或根据法律法规的要求收集和使用，并严格保密。
        <b>
          通常情况下，我们不会与任何公司、组织和个人共享您的个人信息，但以下情形除外：
        </b>
      </Paragraph>
      <Paragraph>
        <b>2.1委托服务提供商：</b>
        为了向您提供海底捞产品和服务，我们可能会委托第三方服务提供商帮助我们提供相关的运营和服务的支持。在此过程之中，
        <b>
          基于该等第三方服务提供商向您提供服务的目的我们会共享与之提供服务必要的个人信息，以实现我们产品和/或服务的功能。
        </b>
        我们在与上述服务供应商合作时，没有也不会许可他们将我们与之共享的信息用于任何其他用途，服务提供商包括以下类型：
      </Paragraph>
      <Title bold>小程序与第三方共享信息清单</Title>
      <img
        className={styles.image}
        alt="小程序与第三方共享信息清单"
        src={`${OSS_CDN}gxqd.png`}
      />
      <Paragraph>
        <b>2.2第三方SDK的使用：</b>
        为提供和优化我们的服务，海底捞外送小程序中内嵌了第三方软件工具开发包（SDK），这些第三方SDK在配合我们向您提供更全面的服务的同时，可能会收集您的个人信息。我们将采取必要方式控制第三方SDK对您个人信息的收集与使用，确保您的个人信息得到有效保护。关于第三方的身份、SDK的名称、类型、收集的个人信息的类型、收集目的以及第三方的隐私政策链接的具体SDK接入与收集个人信息情况如下：
      </Paragraph>
      <img
        className={styles.image}
        alt="海底捞外送（微信、支付宝）小程序内嵌第三方SDK详情"
        src={`${OSS_CDN}zfbwxsdk.png`}
      />
      <img
        className={styles.image}
        alt="海底捞外送（快手）小程序内嵌第三方SDK详情"
        src={`${OSS_CDN}kssdk.png`}
      />
      <Paragraph>
        <b>2.3转让：</b>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      </Paragraph>
      <Paragraph>
        a）根据适用的法律、法规的要求，或者为了协助有关行政机关、司法机关的调查、司法程序，配合有关行政机关、司法机关的强制性要求；
      </Paragraph>
      <Paragraph>
        b）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
      </Paragraph>
      <Paragraph>
        c）在公司发生合并、分立、收购、资产出售、重组或破产清算情形，如涉及到个人信息转让，我们会告知您接收个人信息的公司、组织、个人（合称“接收方”）的名称或者姓名和联系方式，并要求接收方继续受本隐私政策的约束，否则我们将要求接收方重新向您征求授权同意。
      </Paragraph>
      <Title bold>三、我们如何保护您的个人信息</Title>
      <Paragraph>
        3.1我们采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
      </Paragraph>
      <Paragraph>
        3.2互联网并非绝对安全的环境，请注意，您在购买/使用我们的产品/服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在购买/使用我们的产品/服务时共享甚至公开分享相关信息。
      </Paragraph>
      <Paragraph>
        3.3在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话或推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况
      </Paragraph>
      <Title bold>四、我们如何存储您的个人信息</Title>
      <Paragraph>1、存储时间</Paragraph>
      <Paragraph>
        <b>
          我们会根据适用的法律、法规的要求，在达成本隐私政策所述目的所需的最短期限内保留您的个人信息。
        </b>
        在您撤回授权同意、删除个人信息、超出存储时间或注销您的海底捞会员账户时，我们将根据法律法规的要求删除或匿名化处理您的个人信息。
      </Paragraph>
      <Paragraph>2、存储地点</Paragraph>
      <Paragraph>
        原则上，
        <b>
          我们在中国大陆境内收集和产生的个人信息，将存储在中国大陆境内。以下情形下，我们会在履行了法律规定的义务后，向境外实体提供您的个人信息：
        </b>
      </Paragraph>
      <Paragraph>a）适用的法律有明确规定；</Paragraph>
      <Paragraph>b）获得您的明确授权。</Paragraph>
      <Paragraph>
        针对以上情形，我们会通过与境外接收方实体签订合同等形式确保以不低于本隐私政策规定的程度保护您的个人信息。
      </Paragraph>
      <Title bold>五、您如何管理您的个人信息</Title>
      <Paragraph>
        关于您的个人信息是如何被处理的，您享有以下权利，
        <b>
          为行使您的权利，您可以通过本隐私政策末尾“联系我们”一节所述方式联系我们，
        </b>
        以提出相应请求：
      </Paragraph>
      <Paragraph bold>1、查询与更正您的个人信息</Paragraph>
      <Paragraph bold>您可以按照下述指引路径查询或更正您的个人信息：</Paragraph>
      <Paragraph>
        您可以在海底捞外送小程序的“订单”入口，查询最近一年的订单。您可以通过海底捞外送小程序“我的”的入口，进入个人信息页面，以访问您的昵称、性别、联系电话和出生日期。您可以在海底捞外送小程序的“地址管理”页面查询或更正您的个人信息，包括收件人姓名、联系电话、收件地址。
      </Paragraph>
      <Paragraph bold>
        或者您可通过下方【联系我们】所述方式，提出查询、更正我们保有的有关您的个人信息的要求，法律法规规定的例外情况除外。
      </Paragraph>
      <Paragraph bold>2、获取您的个人信息副本</Paragraph>
      <Paragraph>
        如您需要获取我们收集的您的个人信息副本，您可通过海底捞外送小程序的“我的”-“设置”-“隐私”-“个人信息下载”申请。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。请您注意，在不同小程序应用中，路径可能有所差别，具体小程序应用实际路径为准。
      </Paragraph>
      <Paragraph bold>3、删除您的个人信息</Paragraph>
      <Paragraph>
        对于您的部分个人信息，
        <b>
          您可以通过本隐私政策末尾“联系我们”一节所述方式联系我们要求我们进行删除，一旦您删除后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定：
        </b>
      </Paragraph>
      <Paragraph>
        在以下情形中，您可以向我们提出删除您的个人信息的请求：
      </Paragraph>
      <Paragraph>
        a）处理目的已实现、无法实现或者为实现处理目的不再必要；
      </Paragraph>
      <Paragraph>b）如果我们处理您的个人信息的行为违反法律法规；</Paragraph>
      <Paragraph>c）如果我们处理个人信息的行为严重违反了与您的约定；</Paragraph>
      <Paragraph>
        d）如果您不再使用我们的产品或服务，或您主动注销了账号；
      </Paragraph>
      <Paragraph>e）如果您撤回同意隐私政策。</Paragraph>
      <Paragraph>
        特别提醒，为保障安全，我们可能会先要求验证您的身份（如要求您提供书面资料或其他方式）；
        <b>
          当您通过身份验证后，我们会从实现日常业务功能所涉及的系统中删除您的个人信息，使其保持不可被检索、访问的状态。
        </b>
      </Paragraph>
      <Paragraph bold>4、改变或撤回您的授权</Paragraph>
      <Paragraph>
        如前文所述，
        <b>
          我们提供的产品和/或服务的部分功能需要获得您所使用设备的相关权限、推送开关，您可以在授权后随时撤回（或停止）对对应权限/功能的继续授权。
        </b>
      </Paragraph>
      <Paragraph>
        定位权限：【海底捞外送小程序】-【设置】-【位置信息】撤回您对我们访问您定位权限的授权；
      </Paragraph>
      <Paragraph>
        存储权限：【海底捞外送小程序】-【设置】-【用户信息】撤回或者部分撤回您对我们访问您个人信息权限的授权
      </Paragraph>
      <Paragraph>
        消息推送权限：【海底捞外送小程序】-【设置】-【消息管理】撤回或者部分撤回您对我们为您提供推送消息权限的授权。
      </Paragraph>
      <Paragraph bold>
        或者您可以拨打海底捞客服电话：4009107107或向【
        <b className={styles.blue}>kfzx@haidilao.com</b>】
        发送邮件的形式，向我们提出改变或撤回您授权我们收集和处理您的个人信息的范围，以及撤回对隐私政策的同意，当您撤回同意后，我们将不再处理相应的个人信息。请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但您撤回同意的决定，将不会影响我们此前基于您的授权而开展的个人信息处理。
      </Paragraph>
      <Paragraph bold>5、注销</Paragraph>
      <Paragraph>
        您有权申请注销您的海底捞会员账户，您可以通过拨打“4009107107”的方式注销账号，我们将在15个工作日内答复您的请求。
        <b>
          一旦您注销账号，将无法使用我们提供的全线用户产品和/或服务且自动放弃已有的权益，因此请您谨慎操作。除法律法规另有规定外，注销账号之后，我们将停止为您提供我们所有的产品和/或服务，您曾通过该账号使用的我们的产品和/或服务下的所有内容、信息、数据、记录将会被删除或匿名化处理（但法律法规另有规定或监管部门另有要求的除外）。
        </b>
      </Paragraph>
      <Paragraph bold>6、要求解释说明</Paragraph>
      <Paragraph>
        您有权要求我们对您的个人信息处理的规则进行解释说明，您可以通过本隐私政策末尾“联系我们”一节所述方式与我们联系，我们会在法律要求的时限内满足您的合法请求
      </Paragraph>
      <Paragraph bold>7、死者近亲属权利</Paragraph>
      <Paragraph>
        已故用户的近亲属为了自身的合法、正当利益，可以对已故用户的相关个人信息行使本章规定的查阅、复制、更正、删除等权利；已故用户生前另有安排的除外。已故用户的近亲属可以通过本隐私政策末尾“联系我们”一节所述方式与我们联系，我们会在法律要求的时限内满足您的合法请求
      </Paragraph>
      <Paragraph bold>8、响应您的上述请求</Paragraph>
      <Paragraph>
        为保障安全，我们可能会先要求验证您的身份（如要求您提供书面资料或其他方式），然后再处理您的上述请求。
        <b>
          我们在收到您的上述请求后，将在15个工作日内响应您的请求，给予您相关答复。
        </b>
      </Paragraph>
      <Paragraph>
        请您理解，按照特定的法律法规要求，我们可能无法响应您的一些请求，例如，与国家安全、公共利益、履行我们法定义务相关的，以及涉及商业秘密等情形。
      </Paragraph>
      <Title bold>六、 未成年人隐私保护</Title>
      <Paragraph>
        海底捞重视并致力于保护18周岁以下未成年人（以下简称“未成年人”）的隐私，并且无意收集未成年人的个人信息，但是由于生日并不是必须提供的信息，在某些情况下，我们无法识别用户的年龄。
        <b>
          因此，除非征得其法定监护人的同意，未成年人请不要注册帐户或向我们提供自己个人信息。如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
        </b>
      </Paragraph>
      <Title bold>七、 我们如何使用 Cookies 和同类技术</Title>
      <Paragraph>
        7.1为确保我们的产品、服务的正常开展、为您获得更轻松的访问体验，
        <b>我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。</b>
        Cookie 通常包含标识符、站点名称以及一些号码和字符。
      </Paragraph>
      <Paragraph>
        7.2我们或我们的第三方合作商，可能通过Cookie及相关技术收集您的信息，目的是为您提供更加便捷的用户体验。我们亦会严格要求第三方合作商遵守本隐私政策的相关规定。
      </Paragraph>
      <Paragraph>
        7.3如果您的浏览器或浏览器附加服务允许，
        <b>
          您可以通过浏览器设置启用、关闭或管理Cookie。但请注意，如果停用Cookie，您可能无法使用海底捞官方网站的部分功能。
        </b>
      </Paragraph>
      <Title bold>八、本政策的更新</Title>
      <Paragraph>
        <b>我们可能依据法律法规变更或业务发展适时修订本隐私政策。</b>
        如该等修订可能导致您于本隐私政策项下权利实质减损，我们将在修订后通过显著页面通知、公告或其他合理、可行的方式通知您。
        <b>
          如您拟定继续使用我们的服务，应在仔细阅读隐私政策后点击同意，您的点击行为即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。
        </b>
        未经您明确同意，我们不会减损或侵害您依据本政策享有的个人权益。
      </Paragraph>
      <Title bold>九、 与我们取得联系</Title>
      <Paragraph>
        若您需要行使您的上述权利，或对本隐私政策或您本人的个人信息安全存在任何疑问、意见、建议、举报或投诉，以及您的其他顾虑无法在此找到解答，
        <b>可通过选择以下任意一种方式联系我们：</b>
      </Paragraph>
      <Paragraph bold>隐私负责人邮箱：【dataprivacy@haidilao.com】</Paragraph>
      <Paragraph bold>
        联系地址为：【北京市昌平区东小口镇中东路398号1号楼7层】
      </Paragraph>
      <Paragraph bold>邮编：102218 </Paragraph>
      <Paragraph bold>您可拨打海底捞客服电话：4009107107。</Paragraph>
      <Paragraph bold>
        我们将在收到相关疑问、意见、建议、举报或投诉并验证您的身份后15个工作日内响应您的上述请求。
      </Paragraph>
      <Paragraph bold>附录：</Paragraph>
      <Paragraph bold>关联公司</Paragraph>
      <img className={styles.image} alt="关联公司" src={`${OSS_CDN}glgs.png`} />
      <Paragraph bold>个人信息定义：</Paragraph>
      <img
        className={styles.image}
        alt="个人信息定义"
        src={`${OSS_CDN}grxx.png`}
      />
    </div>
  );
};
